let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("377y0")).then(() => parcelRequire('3Pt2u'));